import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e364602a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-check mb-2" }
const _hoisted_2 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dp_field = _resolveComponent("dp-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_dp_field, {
      type: "radio",
      value: _ctx.value,
      modelValue: _ctx.model,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model) = $event)),
      label: _ctx.label,
      name: _ctx.name,
      id: _ctx.id,
      class: _normalizeClass(["form-check-input", { 'is-invalid': _ctx.errors[_ctx.name] }]),
      disabled: _ctx.disabled,
      rules: _ctx.rules
    }, null, 8, ["value", "modelValue", "label", "name", "id", "class", "disabled", "rules"]),
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: _ctx.id,
          class: _normalizeClass(["form-check-label ps-2 mb-0", _ctx.labelClass])
        }, _toDisplayString(_ctx.label), 11, _hoisted_2))
      : _createCommentVNode("", true)
  ]))
}